<template>
	<div>
		
		<main class="body">
			<div class="container-fluid">
				<div class="row m-hide">
					<div class="p-3 mt-4 col-auto col">
						<img src="@/assets/logo.png" alt="" class="w-100" style="height: 60px;">
					</div>
				</div>
		
				<div class="row m-hide">
					<div class="px-3 py-1 text-lg-nowrap col-auto col"><h1 style="font-size: 21px!important">耳炎互动演示工具</h1></div>
				</div>
				<div class="m-show m-header-bar" style="height: 125px;background: #fff;z-index: 12;">
					
				</div>
				<div class="m-show m-header-bar">
		
					<div class="fc-bet">
						<div style="padding:10px">
							<img src="@/assets/logo.png" alt=""  style="height: 40px;">
						</div>
						<div style="padding:10px">
							<label class="btn btn-blue" style="font-size: 12px;" @click="showVideo=true">点击查看操作指南</label>
						</div>
					</div>
					<div class="fc-bet">
						<!-- 移动端切换 -->
						<div style="padding:10px 0 10px 10px;">
							<label class="btn btn-light-blue" style="font-size: 12px;" v-if="isRight" @click="isRightClick(-1)">点击翻转左耳</label>
							<label class="btn btn-blue" style="font-size: 12px;" v-else @click="isRightClick(1)">点击翻转右耳</label>
						</div>
						<div style="padding:10px 0 10px 0px;">
		
							<label class="btn btn-blue" style="font-size: 12px;" @click="clearImagesAll">点击清除选项</label>
						</div>
						<div style="padding:10px 10px 10px 0px;">
							<button type="button" @click="exportImage" class="btn btn-primary fcc" style="font-size: 12px; padding: 4px 12px !important;"><svg id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.33 25.33" height="12" width="12" style="margin-right: 5px;"><polygon points="21.79 7.09 15.2 7.09 15.2 8.11 21 8.11 24.04 20.27 1.3 20.27 4.34 8.11 10.14 8.11 10.14 7.09 3.55 7.09 0 21.28 25.33 21.28 21.79 7.09" fill="#fff" stroke-width="0"></polygon><polygon points="12.16 1.94 12.16 14.19 13.18 14.19 13.18 1.94 16.36 5.13 17.08 4.41 12.66 0 8.25 4.41 8.97 5.13 12.16 1.94" fill="#fff" stroke-width="0"></polygon><rect y="24.33" width="25" height="1" fill="#fff" stroke-width="0"></rect><rect y="22.33" width="25" height="1" fill="#fff" stroke-width="0"></rect></svg>
							<span>下载图片</span>
							</button>
						</div>
		
					</div>
				</div>
		
				<div class="mb-5 row m1000-hide" style="margin-bottom: 1rem !important;">
					<div class="col-12 p-5 col-lg-5 col" style="padding-top: 0rem !important;padding-bottom: 0rem !important;padding-right: 0!important;">
						<div class="img-wrapper"><img src="@/assets/head-illustration.jpg" class=""></div>
					</div><div class="col-12 p-5 col-lg-7 col" style="padding: 0rem !important;padding-bottom: 0rem !important;">
						<div><img src="@/assets/labeled-ear-illustration-zh.png" style="width: 100%;" ></div></div></div>
				
				<div class="row m-hide"><div class="col"><hr></div></div>		
		
				<div class="row">
					<div class="col-lg-8 col-sm-6 col-12">
						<div class="sticky-top">
							<div class="m-btns-box d-flex justify-content-between justify-content-sm-center align-items-center">
								<div class="text-center text-md-center d-flex justify-content-end justify-content-md-center align-items-center pb-3" >
		
									<label class="btn " :class="[!isRight ? 'btn-blue' : 'btn-light-blue' ]" @click="isRightClick(-1)">点击翻转左视图</label>
									<div style="display: block; margin-left: 10px; margin-right: 10px;"></div>
									<label class="btn " :class="[isRight ? 'btn-blue' : 'btn-light-blue' ]" @click="isRightClick(1)">点击翻转右视图</label>
								</div>
								<btn-new-h5 @clearImages="clearImages"></btn-new-h5>
							</div>
							<div class="row">
								<div class="col-12 col-lg-6 d-none d-lg-block col">
									<h3 class="text-secondary text-center">健康耳部</h3>
									<div class="position-relative" >
										<img src="@/assets/healthy-ear.png"
											class="sticky-top  img-fluid"
											:class="{ 'mirror': !isRight}"
											style="transition: all 0.2s ease-in-out 0s" />
											<img :width="logoWidth"
											:height="logoHeight" class="position-absolute bottom-0 " :class="[isRight ? 'start-0' : 'end-0']"
											src="@/assets/logo-bg.svg" alt="virbac logo" style="z-index: 1050" />
									</div>
									<div style="height: 66px"></div>
								</div>
								<div class="col-12 col-sm-12 col-lg-6 text-center col m-screen">
									<div id="stage-wrapper">
										<h3 class="text-primary text-center m-hide">耳炎</h3>
										<div id="dropLayer" ref="dropLayer">
											<div @dragover.prevent @drop="handleDrop" style="background-color: rgba(0, 0, 0, 0.1);">
		
												<v-stage  :config="configKonva"  ref="stageRef" @click="handleStageClick" @tap="handleStageClick">
													<v-layer>
													        <v-rect :config="configRect"></v-rect>
													</v-layer>
													<v-layer >
														<v-image :config="configImage" ref="bgRef"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion1Show">
														<v-image :config="imgArr[0]" ref="ref1"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion2Show">
														<v-image :config="imgArr[1]" ref="ref2"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion3Show">
														<v-image :config="imgArr[2]" ref="ref3"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion4Show">
														<v-image :config="imgArr[3]" ref="ref4"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion5Show">
														<v-image :config="imgArr[4]" ref="ref5"></v-image>
													</v-layer>
		
													<v-layer v-if="toggleAccordion12Show">
														<v-image :config="imgArr[11]" ref="ref12"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion15Show">
														<v-image :config="imgArr[14]" ref="ref15"></v-image>
													</v-layer>
													<v-layer v-if="toggleAccordion16Show">
														<v-image :config="imgArr[15]" ref="ref16"></v-image>
													</v-layer>
													<v-layer>
													<!-- 所有图片 -->
													<v-image
														v-for="(image, index) in images"
														:key="image.id"
														:config="image.config"
														@click="smallImageClick($event, index)"
														@tap="smallImageClick($event, index)"
														@dragstart="smallImageDragStart($event, index)"
		
														@dragmove="smallImageDragEnter($event, index)"
														@dragend="smallImageDragEnd($event, index)"
													></v-image>
		
													<!-- 变换控制器 -->
													<v-transformer
														v-if="transformerVisible"
														:config="transformerConfig"
														ref="transformer"
														@isTransforming="handleTransformEnd"
														@transformmove="handleTransformMove"
													></v-transformer>
		
		
		
														<!-- 自定义删除按钮 -->
														<v-group v-if="selectedIndex > -1" ref="delRef">
															<v-rect
															:config="deleteButtonConfig"
															@click="deleteSelected"
															@tap="deleteSelected"
															/>
															<v-text
															:config="deleteTextConfig"
															@click="deleteSelected"
															@tap="deleteSelected"
															/>
														</v-group>
		
		
		
													</v-layer>
													<v-layer>
		
														<v-image :config="logoImage"></v-image>
													</v-layer>
												</v-stage>
		
		
											</div>
										</div>
										<div class="fcc">
											<button type="button" id="image-export-btn" @click="exportImage"
												class="btn btn-primary fcc" style="margin: 10px; font-size: 12px;">
												<div class="fcc" style="width: 26px;height: 26px;position: relative;overflow: hidden;">
													<svg id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 25.33 25.33" height="16" width="16" style="">
														<polygon
															points="21.79 7.09 15.2 7.09 15.2 8.11 21 8.11 24.04 20.27 1.3 20.27 4.34 8.11 10.14 8.11 10.14 7.09 3.55 7.09 0 21.28 25.33 21.28 21.79 7.09"
															fill="#fff" stroke-width="0"></polygon>
														<polygon
															points="12.16 1.94 12.16 14.19 13.18 14.19 13.18 1.94 16.36 5.13 17.08 4.41 12.66 0 8.25 4.41 8.97 5.13 12.16 1.94"
															fill="#fff" stroke-width="0"></polygon>
														<rect y="24.33" width="25" height="1" fill="#fff" stroke-width="0"></rect>
														<rect y="22.33" width="25" height="1" fill="#fff" stroke-width="0"></rect>
													</svg>
												</div>
												<span>下载图片</span>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-sm-6 col-12 options-box" @click="deselect">
						<div>
							<!-- 右侧加号 -->
							<btn-new @clearImages="clearImages"></btn-new>
		
							<div id="pathology-list" :style="'height:' + pcScrollheight + 'px' ">
								<div class="mt-4 accordion">
									<accordion-item @toggle="toggleAccordion1">
										<template slot="title">
											肿胀/增生/狭窄
										</template>
										<template slot="img">
											<span @click="slideShow(1)" class="form-check-label">点击查看内窥镜图</span>
										</template>
										<p>3级严重程度:</p>
										<div class="form-check">
											<input name="group-edema-level" type="radio" id="group-edema-level-low"
												class="form-check-input" /><label title for="group-edema-level-low"
												class="form-check-label" @click="toggleAccordion1Val=1">等级 1</label>
										</div>
										<div class="form-check">
											<input name="group-edema-level" type="radio" id="group-edema-level-medium"
												class="form-check-input" /><label title for="group-edema-level-medium"
												class="form-check-label" @click="toggleAccordion1Val=2">等级 2</label>
										</div>
										<div class="form-check">
											<input name="group-edema-level" type="radio" id="group-edema-level-high"
												class="form-check-input" /><label title for="group-edema-level-high"
												class="form-check-label" @click="toggleAccordion1Val=3">等级 3</label>
										</div>
									</accordion-item>
		
									<accordion-item @toggle="toggleAccordion2">
										<template slot="title"> 红斑 </template>
										<template slot="img">
											<span @click="slideShow(2)" class="form-check-label">点击查看内窥镜图</span>
										</template>
		
										<p>3级严重程度:</p>
										<div class="form-check">
											<input name="group-inflammation-level" type="radio"
												id="group-inflammation-level-low" class="form-check-input" /><label title
												for="group-inflammation-level-low" @click="toggleAccordion2Val=1" class="form-check-label">等级
												1</label>
										</div>
										<div class="form-check">
											<input name="group-inflammation-level" type="radio"
												id="group-inflammation-level-medium" class="form-check-input" /><label title
												for="group-inflammation-level-medium" @click="toggleAccordion2Val=2" class="form-check-label">等级
												2</label>
										</div>
										<div class="form-check">
											<input name="group-inflammation-level" type="radio"
												id="group-inflammation-level-high" class="form-check-input" /><label title
												for="group-inflammation-level-high" @click="toggleAccordion2Val=3" class="form-check-label">等级
												3</label>
										</div>
									</accordion-item>
		
									<accordion-item @toggle="toggleAccordion3">
										<template slot="title"> 糜烂/溃疡</template>
										<template slot="img">
											<span @click="slideShow(3)" class="form-check-label">点击查看内窥镜图</span>
										</template>
		
										<p>3级严重程度:</p>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-erosion-level-low"
												class="form-check-input" /><label title for="group-erosion-level-low"
												class="form-check-label" @click="toggleAccordion3Val=1">等级 1</label>
										</div>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-erosion-level-medium"
												class="form-check-input" /><label title for="group-erosion-level-medium"
												class="form-check-label" @click="toggleAccordion3Val=2">等级 2</label>
										</div>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-erosion-level-high"
												class="form-check-input" /><label title for="group-erosion-level-high"
												class="form-check-label" @click="toggleAccordion3Val=3">等级 3</label>
										</div>
									</accordion-item>
		
									<accordion-item @toggle="toggleAccordion4">
										<template slot="title"> 耳垢</template>
										<template slot="img">
											<span @click="slideShow(4)" class="form-check-label">点击查看内窥镜图</span>
										</template>
		
										<p>3级严重程度:</p>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-Earwax-level-low"
												class="form-check-input" /><label title for="group-Earwax-level-low"
												class="form-check-label" @click="toggleAccordion4Val=1">等级 1</label>
										</div>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-Earwax-level-medium"
												class="form-check-input" /><label title for="group-Earwax-level-medium"
												class="form-check-label" @click="toggleAccordion4Val=2">等级 2</label>
										</div>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-Earwax-level-high"
												class="form-check-input" /><label title for="group-Earwax-level-high"
												class="form-check-label" @click="toggleAccordion4Val=3">等级 3</label>
										</div>
									</accordion-item>
		
									<accordion-item @toggle="toggleAccordion5">
										<template slot="title"> 脓</template>
										<template slot="img">
											<span @click="slideShow(5)" class="form-check-label">点击查看内窥镜图</span>
										</template>
		
										<p>3级严重程度:</p>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-Pus-level-low"
												class="form-check-input" /><label title for="group-Pus-level-low"
												class="form-check-label" @click="toggleAccordion5Val=1">等级 1</label>
										</div>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-Pus-level-medium"
												class="form-check-input" /><label title for="group-Pus-level-medium"
												class="form-check-label" @click="toggleAccordion5Val=2">等级 2</label>
										</div>
										<div class="form-check">
											<input name="group-erosion-level" type="radio" id="group-Pus-level-high"
												class="form-check-input" /><label title for="group-Pus-level-high"
												class="form-check-label" @click="toggleAccordion5Val=3">等级 3</label>
										</div>
									</accordion-item>
		
									<template v-if="isMobile">
										<accordion-item @toggle="toggleAccordion6">
											<template slot="title">酵母菌（<em>马拉色菌</em>）</template>
											<p>{{ clickTips }}</p>
		
		
												 <MobileDraggable @drag-end="mDragEnd"  menuId="yeasts" :imgUrl="require('@/assets/patho-yeasts-item-fGWvQrg5.png')">
		
												</MobileDraggable>
		
		
										</accordion-item>
									</template>
									<template v-else>
										<accordion-item @toggle="toggleAccordion6">
											<template slot="title">酵母 (<em>马拉色菌属...</em>)</template>
											<p>{{ clickTips }}</p>
		
		
											<img id="yeasts" src="@/assets/patho-yeasts-item-fGWvQrg5.png" width="50"
												class="border border-1 border-light-subtle" draggable="true"
		
												@dragstart="handleDragStart(require('@/assets/patho-yeasts-item-fGWvQrg5.png'),'yeasts')"
												style="touch-action: none" />
		
		
										</accordion-item>
									</template>
		
		
		
									<accordion-item @toggle="toggleAccordion7" v-if="isMobile">
										<template slot="title">球菌</template>
		
										<p>{{ clickTips }}</p>
		
										<MobileDraggable @drag-end="mDragEnd"  menuId="cocci" :imgUrl="require('@/assets/patho-cocci-item-D-zfDzZR.png')">
										</MobileDraggable>
		
									</accordion-item>
									<accordion-item @toggle="toggleAccordion7" v-else>
										<template slot="title">球菌</template>
		
										<p>{{ clickTips }}</p>
										<img id="cocci" src="@/assets/patho-cocci-item-D-zfDzZR.png" width="50"
											class="border border-1 border-light-subtle" draggable="true"
											@dragstart="handleDragStart(require('@/assets/patho-cocci-item-D-zfDzZR.png'),'cocci')"
											style="touch-action: none" />
									</accordion-item>
		
		
		
									<accordion-item @toggle="toggleAccordion8" v-if="isMobile">
										<template slot="title">杆菌
										</template>
		
										<p>{{ clickTips }}</p>
		
		
										<MobileDraggable @drag-end="mDragEnd"  menuId="bacilli" :imgUrl="require('@/assets/patho-bacilli-item-DMdA844b.png')">
										</MobileDraggable>
		
									</accordion-item>
									<accordion-item @toggle="toggleAccordion8" v-else>
										<template slot="title">杆菌</template>
		
										<p>{{ clickTips }}</p>
										<img id="bacilli" src="@/assets/patho-bacilli-item-DMdA844b.png" width="50"
											class="border border-1 border-light-subtle" draggable="true"
											@dragstart="handleDragStart(require('@/assets/patho-bacilli-item-DMdA844b.png'),'bacilli')"
											style="touch-action: none" />
									</accordion-item>
		
									<accordion-item @toggle="toggleAccordion9" v-if="isMobile">
										<template slot="title">异物（草芒）</template>
		
										<p>{{ clickTips }}</p>
		
										<MobileDraggable @drag-end="mDragEnd"  menuId="foreign-body" :imgUrl="require('@/assets/patho-foreign-body-item-BKzFa8S5.png')">
										</MobileDraggable>
		
		
									</accordion-item>
									<accordion-item @toggle="toggleAccordion9" v-else>
										<template slot="title">异物（草芒）</template>
		
										<p>{{ clickTips }}</p>
										<img id="foreign-body" src="@/assets/patho-foreign-body-item-BKzFa8S5.png"
											width="50" class="border border-1 border-light-subtle" draggable="true"
											@dragstart="handleDragStart(require('@/assets/patho-foreign-body-item-BKzFa8S5.png'),'foreign-body')"
											style="touch-action: none" />
									</accordion-item>
		
		
									<accordion-item @toggle="toggleAccordion10" v-if="isMobile">
										<template slot="title">耳螨</template>
		
										<p>{{ clickTips }}</p>
		
										<MobileDraggable @drag-end="mDragEnd"  menuId="otodectes" :imgUrl="require('@/assets/patho-otodectes-item-eIWytimq.png')">
										</MobileDraggable>
		
									</accordion-item>
									<accordion-item @toggle="toggleAccordion10" v-else>
										<template slot="title">耳螨</template>
		
										<p>{{ clickTips }}</p>
										<img id="otodectes" src="@/assets/patho-otodectes-item-eIWytimq.png" width="50"
											class="border border-1 border-light-subtle" draggable="true"
											@dragstart="handleDragStart(require('@/assets/patho-otodectes-item-eIWytimq.png'),'otodectes')"
											style="touch-action: none" />
									</accordion-item>
		
		
									<accordion-item @toggle="toggleAccordion11" v-if="isMobile">
										<template slot="title">蠕形螨</template>
		
										<p>{{ clickTips }}</p>
		
										<MobileDraggable @drag-end="mDragEnd"  menuId="demodex" :imgUrl="require('@/assets/patho-demodex-item-D3jqP4AS.png')">
										</MobileDraggable>
		
									</accordion-item>
		
									<accordion-item @toggle="toggleAccordion11" v-else>
										<template slot="title">蠕形螨</template>
		
										<p>{{ clickTips }}</p>
										<img id="demodex" src="@/assets/patho-demodex-item-D3jqP4AS.png" width="50"
											class="border border-1 border-light-subtle" draggable="true"
											@dragstart="handleDragStart(require('@/assets/patho-demodex-item-D3jqP4AS.png'),'demodex')"
											style="touch-action: none" />
									</accordion-item>
		
		
									<!-- 这个没有下拉。直接返回点击事件 -->
									<accordion-item nolist @toggle="toggleAccordion12">
										<template slot="title">耵聍石（耳塞）</template>
									</accordion-item>
		
		
		
									<accordion-item @toggle="toggleAccordion13" v-if="isMobile">
										<template slot="title">息肉</template>
		
		
										<p>{{ clickTips }}</p>
		
										<MobileDraggable @drag-end="mDragEnd"  menuId="polyp" :imgUrl="require('@/assets/patho-polyp-item-MtPdS1NQ.png')">
										</MobileDraggable>
		
									</accordion-item>
									<accordion-item @toggle="toggleAccordion13" v-else>
										<template slot="title">息肉</template>
										<p>{{ clickTips }}</p><img id="polyp"
											src="@/assets/patho-polyp-item-MtPdS1NQ.png"
											width="50" class="border border-1 border-light-subtle" draggable="true"
											@dragstart="handleDragStart(require('@/assets/patho-polyp-item-MtPdS1NQ.png'),'polyp')"
											style="touch-action: none;">
									</accordion-item>
		
		
		
									<accordion-item @toggle="toggleAccordion14" v-if="isMobile">
										<template slot="title">肿瘤
											(结节)</template>
											<p>{{ clickTips }}</p>
											<MobileDraggable @drag-end="mDragEnd"  menuId="neoplasia" :imgUrl="require('@/assets/patho-neoplasia-item-DytluiRf.png')">
											</MobileDraggable>
									</accordion-item>
									<accordion-item @toggle="toggleAccordion14" v-else>
										<template slot="title">肿瘤
											(结节)</template>
											<p>{{ clickTips }}</p>
												<img id="neoplasia" src="@/assets/patho-neoplasia-item-DytluiRf.png"
													width="50" class="border border-1 border-light-subtle" draggable="true"
													@dragstart="handleDragStart(require('@/assets/patho-neoplasia-item-DytluiRf.png'),'neoplasia')"
													style="touch-action: none" />
									</accordion-item>
		
		
									<!-- 这个没有下拉。直接返回点击事件 -->
									<accordion-item nolist @toggle="toggleAccordion15">
										<template slot="title">中耳内物质（耳垢、脓液等）</template>
									</accordion-item>
		
		
		
									<accordion-item @toggle="toggleAccordion16">
										<template slot="title">鼓膜外观									</template>
		
										<div class="form-check">
														<input name="group-eardrum-aspect-level" type="radio"
															id="group-eardrum-aspect-level-ruptured-eardrum"
															class="form-check-input" /><label title
															for="group-eardrum-aspect-level-ruptured-eardrum"
															class="form-check-label" @click="toggleAccordion16Val=1">鼓膜破裂
														</label>
													</div>
													<div class="form-check">
														<input name="group-eardrum-aspect-level" type="radio"
															id="group-eardrum-aspect-level-absent-eardrum"
															class="form-check-input" /><label title
															for="group-eardrum-aspect-level-absent-eardrum"
															class="form-check-label" @click="toggleAccordion16Val=2">鼓膜缺失</label>
													</div>
													<div class="form-check">
														<input name="group-eardrum-aspect-level" type="radio"
															id="group-eardrum-aspect-level-tympanic-lesions"
															class="form-check-input" /><label title
															for="group-eardrum-aspect-level-tympanic-lesions"
															class="form-check-label" @click="toggleAccordion16Val=3">鼓膜病变（纤维化，硬化）</label>
													</div>
													<div class="form-check">
														<input name="group-eardrum-aspect-level" type="radio"
															id="group-eardrum-aspect-level-tympanic-lesions-ruptured-eardrum"
															class="form-check-input" /><label title
															for="group-eardrum-aspect-level-tympanic-lesions-ruptured-eardrum"
															class="form-check-label" @click="toggleAccordion16Val=4">伴有鼓膜破损的鼓膜病变</label>
													</div>
									</accordion-item>
		
							</div>
						</div>
					</div>
				</div>
			</div>
			</div>
			<div class="downImgMask" v-if="showImgDown" @click="showImgDown=false">
				<img :src="downImg" width="100%" alt="" @tap.prevent="">
				<div>
					长按图片保存图片
				</div>
			</div>
		
		
		
			<!-- 各等级图片 -->
			<pop-img-slides ref="slides" :title="swiperTitle" :imgs="swiperImgs" v-if="showBigImgs"></pop-img-slides>
		
		
		
		
			<!-- 滚动条 -->
			<div class="m-show">
				<div class="m-scroll">
					<div class="m-scroll-bar f-pr" :style="'top:' + barTop + 'px'"></div>
				</div>
			</div>
		
		
		
		</main>
		
		
		
		<main class="help-bg" v-if="showVideo">
			<div class="container-fluid">
				
				<div class="m-show m-header-bar">
		
					<div class="fc-bet">
						<div style="padding:10px">
							<img src="@/assets/logo.png" alt=""  style="height: 40px;">
						</div>
						<div style="padding:10px">
							<label class="btn btn-blue" style="font-size: 12px;" @click="showVideo=false">返回</label>
						</div>
					</div>
					
				</div>
		
				<div style="padding-top: 60px;">
		
		    <video :src="url" controls class="w-100 block" style="background: #000;"></video>
		
		  </div>
			</div>
		</main>
	</div>
	
	

</template>

<script>
import { Dialog } from 'vant';
import bgimg from "@/assets/healthy-ear.png";
import logoimg from "@/assets/logo-bg.svg";
import w from "@/assets/refresh-one.png";

import edema1 from "@/assets/patho-edema-low-3lUrGL0M.png"
import edema2 from "@/assets/patho-edema-medium-ClvhNAPl.png"
import edema3 from "@/assets/patho-edema-high-BwzlZRSZ.png"

import erythema1 from "@/assets/patho-inflammation-low-CBVQhxZF.png"
import erythema2 from "@/assets/patho-inflammation-medium-aTmiPuSZ.png"
import erythema3 from "@/assets/patho-inflammation-high-DZojNc3U.png"

import erosion1 from "@/assets/patho-erosion-low-BBs4bIzG.png"
import erosion2 from "@/assets/patho-erosion-medium-D74Ibq03.png"
import erosion3 from "@/assets/patho-erosion-high-C8bWfBKd.png"

import earwax1 from "@/assets/patho-cerumen-low-DYOKQYJd.png"
import earwax2 from "@/assets/patho-cerumen-medium-Ct7X8pEe.png"
import earwax3 from "@/assets/patho-cerumen-high-CyKZGANK.png"

import pus1 from "@/assets/patho-pus-low-CBmu86CR.png"
import pus2 from "@/assets/patho-pus-medium-CIPvIo9U.png"
import pus3 from "@/assets/patho-pus-high-CVutrbLR.png"



import ceruminolite from "@/assets/patho-ceruminolite-BpIaeh-b.png"
import material from "@/assets/patho-material-Bv3vzH20.png"


import eardrum1 from "@/assets/patho-pierced-eardrum-DrOt73Ot.png"
import eardrum2 from "@/assets/patho-missing-eardrum-jgPhTLo9.png"
import eardrum3 from "@/assets/patho-tympanic-lesions-67OGZhE_.png"
import eardrum4 from "@/assets/patho-tympanic-lesions-ruptured-eardrum-DII9Cy_q.png"



import { Tween, Easings } from 'konva'; // 从 konva 库引入 Tween 和 Easings
import MobileDraggable from '../components/MobileDraggable'
export default {
	components: {
		MobileDraggable,
	},
	data() {
		return {
			showBigImgs:false,
			// mImgs:[
			// 	{
			// 		url:"https://dummyimage.com/400x200"
			// 	}
			// ],
			url:"",
			showVideo:false,
			drapImgWidth:40,
			windowHeight: 0,   // 窗口可见高度 
			pageHeight: 0,     // 文档总高度 
			visualHeight:0,  	
			
			
			scrollY: 0,       // 垂直滚动距离 
			
			scrollAreaHeight:0,	
				
			isMobile:false,
			// 拖拽加图
			transformerConfig: {
				rotateEnabled: true,
				// borderStroke: '#0099ff',
				// anchorFill: '#ffffff',
				// anchorStroke: '#0099ff',
				// anchorSize: 10,
				anchorSize:"10",
				flipEnabled: !1,
				centeredScaling: !0,
				
				enabledAnchors: ["top-left", "top-right", "bottom-left", "bottom-right"],
				rotateAnchorCursor: "ew-resize",
				keepRatio: !0,
				anchorStyleFunc: (anchor) => this.customizeAnchor(anchor),
				boundBoxFunc: (oldBox, newBox) => {
					return newBox.width  < 20 || newBox.height  < 20 ? oldBox : newBox;
				}
			},
			images: [],
			selectedNode: null,
			selectedIndex: -1,
			transformerVisible: false ,
			dragImageSrc:'',
			dragImageId:'',

			isRight:true,
			toggleAccordion1Show:false,
			toggleAccordion2Show:false,
			toggleAccordion3Show:false,
			toggleAccordion4Show:false,
			toggleAccordion5Show:false,
			toggleAccordion6Show:false,
			toggleAccordion7Show:false,
			toggleAccordion8Show:false,
			toggleAccordion9Show:false,
			toggleAccordion10Show:false,
			toggleAccordion11Show:false,
			toggleAccordion12Show:false,
			toggleAccordion13Show:false,
			toggleAccordion14Show:false,
			toggleAccordion15Show:false,
			toggleAccordion16Show:false,
			toggleAccordion1Val:0,
			toggleAccordion2Val:0,
			toggleAccordion3Val:0,
			toggleAccordion4Val:0,
			toggleAccordion5Val:0,
			toggleAccordion6Val:0,
			toggleAccordion7Val:0,
			toggleAccordion8Val:0,
			toggleAccordion9Val:0,
			toggleAccordion10Val:0,
			toggleAccordion11Val:0,
			toggleAccordion12Val:0,
			toggleAccordion13Val:0,
			toggleAccordion14Val:0,
			toggleAccordion15Val:0,
			toggleAccordion16Val:0,

			configKonva: {
				width: 200,
				height: 200,
			},
			configImage: {
				x: 0,
				y: 0,
				width: 200,
				height: 200,
				scaleX: 1,
				scaleY: 1,
				offsetX: 0,
				offsetY: 0,
				image: null,
			},
			logoImage: {
				x: 0,
				y: 0,
				width: 200,
				height: 200,
				image: null,
			},
			imgArr:[],

			// clickTips:"拖放，然后单击它以确定方向"

			showImgDown:false,
			downImg:"",


			
			deleteButtonConfig: {
				x: 30,
				y: 30,
				width: 16,
				height:16,
				fill: 'red',
				cornerRadius: 100,
			},
			deleteTextConfig: {
				x: 30,
				y: 30,
				text: '×',
				fontSize: 12,
				fill: 'white',
				align: 'center',
				width: 16,
				height: 16,
				verticalAlign: 'middle'
			}
			,
			anchorImage:"",
			dropLayerInfo:{
				x: 0,
				y: 0,
				width: 0,
				height: 0,
			},
			swiperTitle:"",
			swiperImgs:[],

		};
	},
	computed: {
		configRect(){
			var data  = {
				x: 0,
				y: 0,
				width: this.configKonva.width,
				height: this.configKonva.width,
				fill: '#fff',
			}
			return data;
		},
		ratio() {
			return (this.configKonva.width / 2048) || 1;
		},
		logoWidth() {
			return this.configKonva.width / 4;
		},
		logoHeight() {
			return this.configKonva.height * 145 / 1200;
		},
		clickTips(){
			return this.isMobile ? "点击拖动下图，可放置到耳部相应位置，支持旋转及调整大小" : "点击拖动下图，可放置到耳部相应位置，支持旋转及调整大小"
			//return "拖放，然后单击它以确定方向"
		},
		pcScrollheight(){
			return this.configKonva.height + 66 + 24
		},
		// 滚动的高度实时
		wapScrollHeight(){
			
			return this.pageHeight - this.visualHeight
		},
		barTop(){
			// console.log("3哥高度",this.scrollAreaHeight,this.scrollY,this.wapScrollHeight,this.scrollAreaHeight  * this.scrollY / this.wapScrollHeight)
			return this.scrollAreaHeight  * this.scrollY / this.wapScrollHeight
		}
	},
	watch: {

		// selectedIndex() {
		// 	this.updateDeleteButtonPosition();
		// },

		toggleAccordion1Val(a){
			console.log(a)
			var that = this
			const img = new Image();
			switch (a) {
				case 1:
					img.src = edema1;
					break;
				case 2:
					img.src = edema2;
					break;
				case 3:
					img.src = edema3;
					break;
				default:
					img.src = null
					break;
			}
			img.onload = () => {
				this.imgArr[0].image = img;
			}
		},

		toggleAccordion2Val(a){
			console.log(a)
			var that = this
			const img = new Image();
			switch (a) {
				case 1:
					img.src = erythema1;
					break;
				case 2:
					img.src = erythema2;
					break;
				case 3:
					img.src = erythema3;
					break;
				default:
					img.src = null
					break;
			}
			img.onload = () => {
				this.imgArr[1].image = img;
			}
		},

		toggleAccordion3Val(a){
			console.log(a)
			var that = this
			const img = new Image();
			switch (a) {
				case 1:
					img.src = erosion1;
					break;
				case 2:
					img.src = erosion2;
					break;
				case 3:
					img.src = erosion3;
					break;
				default:
					img.src = null
					break;
			}
			img.onload = () => {
				this.imgArr[2].image = img;
			}
		},

		toggleAccordion4Val(a){
			console.log(a)
			var that = this
			const img = new Image();
			switch (a) {
				case 1:
					img.src = earwax1;
					break;
				case 2:
					img.src = earwax2;
					break;
				case 3:
					img.src = earwax3;
					break;
				default:
					img.src = null
					break;
			}
			img.onload = () => {
				this.imgArr[3].image = img;
			}
		},
		toggleAccordion5Val(a){
			console.log(a)
			var that = this
			const img = new Image();
			switch (a) {
				case 1:
					img.src = pus1;
					break;
				case 2:
					img.src = pus2;
					break;
				case 3:
					img.src = pus3;
					break;
				default:
					img.src = null
					break;
			}
			img.onload = () => {
				this.imgArr[4].image = img;
			}
		},


		toggleAccordion16Val(a){
			console.log("16",a)
			var that = this
			const img = new Image();
			switch (a) {
				case 1:
					img.src = eardrum1;
					break;
				case 2:
					img.src = eardrum2;
					break;
				case 3:
					img.src = eardrum3;
					break;
				case 4:
					img.src = eardrum4;
					break;
				default:
					img.src = null
					break;
			}
			img.onload = () => {
				this.imgArr[15].image = img;
			}
		},

	},
	mounted() {


		//this.isMobile()
		// 确保DOM完全加载
		this.$nextTick(() => {

			//十六个大图
			setTimeout(() => {
				this.isRight = true
			}, 50);
			for (var i = 0; i < 16; i++) {
				this.imgArr.push({
							x: 0,
							y: 0,
							width: 200,
							height: 200,
							scaleX: 1,
							scaleY: 1,
							offsetX: 0,
							offsetY: 0,
							image: null,
				})
			}
			this.init()

		});

		this.getScrollHeight()

		//改变浏览器宽高的时候
		window.onresize = () => {

			this.init()
			this.getScrollHeight()
		};

		// 预加载锚点图片
		const image = new Image();
		image.src  = w;  // 替换为你的图片路径
		image.onload  = () => {
			this.anchorImage  = image;
			this.$forceUpdate(); // 触发重新渲染
		};


		
		// 主监听器（被动模式）
		  window.addEventListener('scroll',  this.handleScroll,  { passive: true })
		  
		

	},
	
	beforeDestroy() {
	  window.removeEventListener('scroll',  this.handleScroll) 
	
	},
	methods: {
		
		
		handleScroll() {
		  
		    const currentY = window.scrollY  
		      || document.documentElement.scrollTop  
		      || document.body.scrollTop  
		    
		    // console.log("scrollY",currentY)
		    this.scrollY  = currentY 
		  },
		slideShow(i){
			this.showBigImgs = false
			switch (i){
				case 1:
					this.swiperTitle = "肿胀/增生/狭窄"
					this.swiperImgs = [
						require('@/assets/1/0.jpg'),
						require('@/assets/1/1.jpg'),
						require('@/assets/1/2.jpg'),
						require('@/assets/1/3.jpg')
					]
					break;
				case 2:
					this.swiperTitle = "红斑"
					this.swiperImgs = [
						require('@/assets/2/0.jpg'),
						require('@/assets/2/1.jpg'),
						require('@/assets/2/2.jpg'),
						require('@/assets/2/3.jpg')
					]
					break;
				case 3:
					this.swiperTitle = "糜烂/溃疡"
					this.swiperImgs = [
						require('@/assets/3/0.jpg'),
						require('@/assets/3/1.jpg'),
						require('@/assets/3/2.jpg'),
						require('@/assets/3/3.jpg')
					]
					break;
				case 4:
					this.swiperTitle = "耳垢"
					this.swiperImgs = [
						require('@/assets/4/0.jpg'),
						require('@/assets/4/1.jpg'),
						require('@/assets/4/2.jpg'),
						require('@/assets/4/3.jpg')
					]
					break;
				case 5:
					this.swiperTitle = "脓"
					this.swiperImgs = [
						require('@/assets/5/0.jpg'),
						require('@/assets/5/1.jpg'),
						require('@/assets/5/2.jpg'),
						require('@/assets/5/3.jpg')
					]
					break;
				default:
					break;
			}
			console.log('')
			var that  =this
			this.$nextTick(()=>{
				that.showBigImgs = true
				setTimeout(()=>{
					that.$refs.slides.open()
				},100)
			})
			
		},
		toVideo(){
			// this.$router.push({
			// 	path: '/article'
			// })
		},
		clearImagesAll(){
			// window.location.reload();
			
			Dialog.confirm({
			  overlayClass:"overlayClass",
			  message: '您还未保存图片，是否确认清除全部标记',
			  confirmButtonText:"是",
			  cancelButtonText:"否",
			  confirmButtonColor:"#18468E"
			})
			  .then(() => {
			    // on confirm
				window.location.reload();
			  })
			  .catch(() => {
			    // on cancel
			  });
			  
			  
			  
			  
		},
		clearImages(){
			this.images = []
		},
		dropLayerRect(){
			var that = this
			this.$nextTick(() => {
				const rect = this.$refs.dropLayer.getBoundingClientRect();
				that.dropLayerInfo = {
					x: rect.left,
					y: rect.top,
					width: that.configKonva.width,
					height: that.configKonva.height,
				}
				// console.log("dropLayerInfo",JSON.stringify(this.dropLayerInfo))
			});
		},

		mDragEnd(e){
			var that = this
			console.log("wap拖拽结束",e)
			if(e.x > this.dropLayerInfo.x && e.x < this.dropLayerInfo.x + this.dropLayerInfo.width && e.y > this.dropLayerInfo.y && e.y < this.dropLayerInfo.y + this.dropLayerInfo.height){
				// console.log("wap拖拽结束",'在框子内')
				this.dragImageSrc = e.img
				this.dragImageId = e.menuid

				var position = {
					x:e.x,
					y:e.y
				}
				console.log("position",position,position.x)
				const newImage = {
					id: 'image-' + Date.now(),
					menuid:e.menuid,
					config: {
						id: 'image-' + Date.now(),  // 确保有唯一ID
						//拖拽进入的 坐标 ，不管是否镜像
						x:position.x,
						y:position.y,
						// x1 right 时候坐标 x2 left的
						x1:position.x,
						x2:position.x,
						y1:position.y,
						y2:position.y,
						// 默认宽度
						width: that.drapImgWidth,
						height: that.drapImgWidth,
						draggable: true,
						//修改正负可以镜像
						scaleX: this.isRight ? 1 : -1,
						scaleY: 1,
						//offsetX和offsetY是图片中心点，用来计算图片的偏移
						offsetX: that.drapImgWidth / 2,
						offsetY: that.drapImgWidth / 2,
						image: null,
						rotation:0
					}
				};

				this.images.push(newImage);
				const index = this.images.length  - 1;
				const imageObj = new Image();
				imageObj.src  = this.dragImageSrc;
				imageObj.onload  = () => {
					const maxDimension = that.drapImgWidth;
					const minDimension = 20;
					let width = imageObj.width;
					let height = imageObj.height;
					if (width > height) {
						height = (height / width) * maxDimension;
						width = maxDimension;
					} else {
						width = (width / height) * maxDimension;
						height = maxDimension;
					}
					this.$set(this.images[index].config,  'image', imageObj);
					
					console.log('翻倍尺寸前',width,height)
					if(width < 20 || height < 20){
						if(width > height){
							width = (width / height) * minDimension;
							height = minDimension;
							
						}else{
							height = (height / width) * minDimension;
							width = minDimension;
							
						}
						console.log('翻倍尺寸后',width,height)
					}
					
					
					this.$set(this.images[index].config,  'width', width);
					this.$set(this.images[index].config,  'height', height);
					
					this.$set(this.images[index].config,  'x', position.x - that.dropLayerInfo.x + (width / 2));
					this.$set(this.images[index].config,  'y', position.y - that.dropLayerInfo.y + (height / 2));
					this.$set(this.images[index].config,  'offsetX', width / 2);
					this.$set(this.images[index].config,  'offsetY', height /2 );
					
					
					
					
					
				};

				console.log("移动端拖拽小图后的数据",this.images)

			}

		},
		onDragStart(e){
			console.log("wap拖拽",e)
		},

		customizeAnchor(anchor) {
			// 只处理控制点锚点（忽略旋转锚点）
			// console.log('anchor.name()',anchor.name())
			if (anchor.name().includes('rotater')){
				// 完全重置锚点样式
				anchor.fill('rgba(0,0,0,0)');  // 透明背景
				anchor.strokeEnabled(false);    // 无边框
				anchor.width(40);                // 宽度 40px
				anchor.height(40);               // 高度 40px
				anchor.cornerRadius(20);         // 圆形锚点（半径=宽度/2）
				anchor.offsetX(20);              // X 轴偏移（居中）
				anchor.offsetY(20);               // Y 轴偏移
				anchor.strokeEnabled(!1);        // 禁用描边
				// 使用图片填充（如果图片已加载）
				if (this.anchorImage)  {
					anchor.fillPatternImage(this.anchorImage);
					anchor.fillPatternRepeat('no-repeat');
					anchor.fillPriority('pattern');
					anchor.fillPatternX(20  - 40  / 2) // 图案水平居中
				}
			};



		},
		handleDragStart(img,menuid){

			console.log("========================================")
			this.dragImageSrc = img
			this.dragImageId = menuid
			console.log("拖拽的图片和栏目id",this.dragImageSrc,this.dragImageId)


		},
		// handleClickStart(img,menuid){

		// 	console.log("========================================")
		// 	this.dragImageSrc = img
		// 	this.dragImageId = menuid
		// 	console.log("点击的图片和栏目id",this.dragImageSrc,this.dragImageId)
		// 	this.handleCLickDrop()

		// },
		handleDrop(event){
			event.preventDefault();
			var that = this
			const stage = this.$refs.stageRef.getNode();
			var position = {}

				stage.setPointersPositions(event);
				position = stage.getPointerPosition();
				console.log(stage,position)




			const newImage = {
				id: 'image-' + Date.now(),
				menuid:this.dragImageId,
				config: {
					id: 'image-' + Date.now(),  // 确保有唯一ID
					//拖拽进入的 坐标 ，不管是否镜像
					x:position.x,
					y:position.y,
					// x1 right 时候坐标 x2 left的
					x1:position.x,
					x2:position.x,
					y1:position.y,
					y2:position.y,
					// 默认宽度
					width: that.drapImgWidth,
					height: that.drapImgWidth,
					draggable: true,
					//修改正负可以镜像
					scaleX: this.isRight ? 1 : -1,
					scaleY: 1,
					//offsetX和offsetY是图片中心点，用来计算图片的偏移
					offsetX: that.drapImgWidth / 2,
					offsetY: that.drapImgWidth / 2,
					image: null,
					rotation:0
				}
			};

			this.images.push(newImage);

			const index = this.images.length  - 1;
			const imageObj = new Image();
			imageObj.src  = this.dragImageSrc;
			console.log("-------------------------------------- ")
				console.log("dragImageSrc: ",this.dragImageSrc)
				console.log("imageObj: ",imageObj)
			imageObj.onload  = () => {
				// 计算合适的尺寸，宽高取最大的设置为100
				
				const maxDimension = that.drapImgWidth;
				const minDimension = 20;
				let width = imageObj.width;
				let height = imageObj.height;
				if (width > height) {
					height = (height / width) * maxDimension;
					width = maxDimension;
				} else {
					width = (width / height) * maxDimension;
					height = maxDimension;
				}
				this.$set(this.images[index].config,  'image', imageObj);
				
				console.log('翻倍尺寸前',width,height)
				if(width < 20 || height < 20){
					if(width > height){
						width = (width / height) * minDimension;
						height = minDimension;
						
					}else{
						height = (height / width) * minDimension;
						width = minDimension;
						
					}
					console.log('翻倍尺寸后',width,height)
				}
				
				
				this.$set(this.images[index].config,  'width', width);
				this.$set(this.images[index].config,  'height', height);
				this.$set(this.images[index].config,  'offsetX', width / 2);
				this.$set(this.images[index].config,  'offsetY', height /2 );
			};

			console.log("拖拽小图后的数据",this.images)
		},
		
		handleStageClick(){
			this.deselect();
		},
		smallImageClick(event, index) {
			event.cancelBubble  = true;
			this.selectNode(index);


			this.images[index].config.x  = event.target.x();
			this.images[index].config.y  = event.target.y();
			var maxHeight = event.target.height() > event.target.width() ? event.target.height() : event.target.width();
			this.deleteButtonConfig  = {
				...this.deleteButtonConfig,
				x: event.target.x() - 8,
				y: event.target.y() - 8 ,

			};

			this.deleteTextConfig  = {
				...this.deleteTextConfig,
				x: event.target.x() - 8,
				y: event.target.y() - 8,

			};


		},
		smallImageDragStart(event, index) {
			this.selectNode(index);



		},
		smallImageDragEnter(event, index) {
			console.log("拖拽中",this.images[index].config)


			this.images[index].config.x  = event.target.x();
			this.images[index].config.y  = event.target.y();

			var maxHeight = event.target.height() > event.target.width() ? event.target.height() : event.target.width();
			this.deleteButtonConfig  = {
				...this.deleteButtonConfig,
				x: event.target.x() - 8,
				y: event.target.y() - 8,

			};

			this.deleteTextConfig  = {
				...this.deleteTextConfig,
				x: event.target.x() - 8,
				y: event.target.y() - 8,

			};

		},
		smallImageDragEnd(event, index) {
			this.images[index].config.x  = event.target.x();
			this.images[index].config.y  = event.target.y();
			console.log("拖拽后改变xy",this.images[index].config)





		},
		selectNode(index) {
			if (this.selectedIndex  === index) return;
			this.deselect();
			this.selectedIndex  = index;
			this.selectedNode  = this.images[index];
			this.transformerVisible  = true;
			this.$nextTick(() => {
				const stage = this.$refs.stageRef.getStage();
				const node = stage.findOne('#'  + this.selectedNode.config.id);
				this.$nextTick(() => {
					if (node && this.$refs.transformer)  {
						const transformerNode = this.$refs.transformer.getNode();
						transformerNode.nodes([node]);
						console.log('transformerNode',transformerNode)
					}
				});
				// console.log("选择当前节点",stage,node,this.$refs.transformer)

			});
		},
		
		handleTransformMove(){
			console.log('放大缩小更新数据')
		},
		handleTransformEnd(){
			
				const node = this.$refs.transformer.getNode().nodes()[0];
				this.images[this.selectedIndex].config.x = node.x();
				this.images[this.selectedIndex].config.y = node.y();
				this.images[this.selectedIndex].config.scaleX = node.scaleX();
				this.images[this.selectedIndex].config.scaleY = node.scaleY();
				this.images[this.selectedIndex].config.rotation = node.rotation();
				console.log("拖拽结束后更新数据",node.x(),node.y(),node.rotation())


				 // 确保变换矩阵正确更新
				node.getLayer().batchDraw();


				this.deleteButtonConfig  = {
					...this.deleteButtonConfig,
					x: node.x() - 8,
					y: node.y() - 8 ,

				};

				this.deleteTextConfig  = {
					...this.deleteTextConfig,
					x: node.x() - 8,
					y: node.y() - 8 ,

				};



		},
		deselect() {
			if (this.selectedIndex  !== -1) {
				this.selectedIndex  = -1;
				this.selectedNode  = null;
				this.transformerVisible  = false;
			}
			if(this.isMobile){
				var that  = this
				setTimeout(()=>{
					that.getScrollHeight()
				},350)
			}
		},

		deleteSelected() {
			if (this.selectedIndex  !== -1) {
				this.images.splice(this.selectedIndex,1);
				this.deselect();
			}
		},
		init(){
			//获取 healthy-image 的宽高
			let healthyImage = document.getElementById("dropLayer");
			this.$nextTick(() => {
				this.configKonva.width = healthyImage.offsetWidth;
				this.configKonva.height = healthyImage.offsetWidth;

				this.imgBg()
				this.logoBg()


			});
			this.isMobile2()
			this.dropLayerRect()
		},
		tweenAnimate(node,i){
			var that = this
			const tween = new Tween({
				node: that.$refs[node].getNode(),
				duration: 0.2, // 动画持续时间，单位秒
				scaleX: i,
			});
			tween.play();
		},
		isRightClick(i){

			if(i == 1 && this.isRight) return;
			if(i == -1 && !this.isRight) return;



			var that = this
			const tween = new Tween({
				node: that.$refs.bgRef.getNode(),
				duration: 0.2, // 动画持续时间，单位秒
				scaleX: i,
			});
			tween.play();

			if(this.toggleAccordion1Show){
				this.tweenAnimate('ref1',i)
			}
			if(this.toggleAccordion2Show){
				this.tweenAnimate('ref2',i)
			}
			if(this.toggleAccordion3Show){
				this.tweenAnimate('ref3',i)
			}
			if(this.toggleAccordion4Show){
				this.tweenAnimate('ref4',i)
			}
			if(this.toggleAccordion5Show){
				this.tweenAnimate('ref5',i)
			}

			if(this.toggleAccordion12Show){
				this.tweenAnimate('ref12',i)
			}

			if(this.toggleAccordion15Show){
				this.tweenAnimate('ref15',i)
			}
			if(this.toggleAccordion16Show){
				this.tweenAnimate('ref16',i)
			}

			if(i == 1){
				this.isRight = true
				that.logoImage.x = 0
			}else{
				this.isRight = false
				that.logoImage.x = that.configKonva.width - that.logoImage.width
			}

			// 大图
			this.imgArr.map(item=>{
				item.scaleX = i
			})
			// 添加的小图
			this.images.map(item=>{
				// if(this.isRight){
				// 	item.config.x = item.config.x1
				// }else{
				// 	item.config.x = item.config.x2
				// }
				// item.config.scaleX = i
				// item.config.scaleX = - (item.config.scaleX)
				// item.config.scaleY = -item.config.scaleY
				console.log("原.x",item.config.x)
				item.config.x = that.configKonva.width - item.config.x
				console.log("新.x",item.config.x,that.configKonva.width,item.config.width)
			})


			if(this.selectedIndex > -1){
				this.deleteButtonConfig.x = this.images[this.selectedIndex].config.x - 8
				this.deleteButtonConfig.y = this.images[this.selectedIndex].config.y - 8
				this.deleteTextConfig.x = this.images[this.selectedIndex].config.x - 8
				this.deleteTextConfig.y = this.images[this.selectedIndex].config.y - 8

			}
			
			
			console.log("点击切换后xy",this.images[this.selectedIndex].config)
			
			
			// 重新绘制舞台以反映镜像后的效果
			this.$nextTick(() => {
			  this.$refs.stageRef.getNode().draw();
			});
			
		},
		//背景图
		imgBg(){
			var that = this
			const img = new Image();
			img.src = bgimg;

			img.onload = () => {
				const { width: imgWidth, height: imgHeight } = img;
				this.configImage.image = img;
				this.configImage.width = imgWidth * this.ratio;
				this.configImage.height = imgHeight * this.ratio;
				this.configImage.offsetX  = this.configImage.width / 2
				this.configImage.offsetY  = this.configImage.height / 2
				this.configImage.x  = this.configImage.width / 2
				this.configImage.y  = this.configImage.height / 2
				if(this.isRight){
					//logo在左边
					this.configImage.scaleX = 1
				}else{
					//logo在右边
					this.configImage.scaleX = -1
				}
				//十六个大图
				for (var i = 0; i < 16; i++) {
					this.imgArr[i].x=that.configImage.width / 2
					this.imgArr[i].y=that.configImage.height / 2
					this.imgArr[i].width=imgWidth * that.ratio
					this.imgArr[i].height=imgHeight * that.ratio
					this.imgArr[i].offsetX=that.configImage.width / 2
					this.imgArr[i].offsetY=that.configImage.height / 2
				}
			};
		},
		// logo图
		logoBg(){
			const img = new Image();
			img.src = logoimg;
			img.onload = () => {
				this.logoImage.width = this.logoWidth;
				this.logoImage.height = this.logoHeight;
				this.logoImage.image = img;
			};

			this.logoImage.y  =  this.configKonva.width  - this.logoHeight
			if(this.isRight){
				//logo在左边
				this.logoImage.x =  0
			}else{
				//logo在右边
				this.logoImage.x  =  this.configKonva.width  - this.logoWidth
			}

		},



		toggleAccordion1(e){
			this.toggleAccordion1Show = e
		},
		toggleAccordion2(e){
			this.toggleAccordion2Show = e
		},
		toggleAccordion3(e){
			this.toggleAccordion3Show = e
		},
		toggleAccordion4(e){
			this.toggleAccordion4Show = e
		},
		toggleAccordion5(e){
			this.toggleAccordion5Show = e
		},
		toggleAccordion6(e){
			this.toggleAccordion6Show = e
			if(!e){
				console.log("yeasts",this.images)
				const filteredArray = this.images.filter(item  => item.menuid  !== "yeasts");
				this.images = filteredArray
			}
		},
		toggleAccordion7(e){
			this.toggleAccordion7Show = e
			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "cocci");
				this.images = filteredArray

			}
		},
		toggleAccordion8(e){
			this.toggleAccordion8Show = e
			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "bacilli");
				this.images = filteredArray
			}
		},
		toggleAccordion9(e){
			this.toggleAccordion9Show = e

			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "foreign-body");
				this.images = filteredArray
			}
		},
		toggleAccordion10(e){
			this.toggleAccordion10Show = e

			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "otodectes");
				this.images = filteredArray
			}

		},
		toggleAccordion11(e){
			this.toggleAccordion11Show = e
			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "demodex");
				this.images = filteredArray
			}
		},
		toggleAccordion12(e){
			this.toggleAccordion12Show = e

			// 添加图片
			const img = new Image();
			img.src = ceruminolite;
			img.onload = () => {
				this.imgArr[11].image = img;
			}
		},
		toggleAccordion13(e){
			this.toggleAccordion13Show = e


			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "polyp");
				this.images = filteredArray
			}


		},
		toggleAccordion14(e){
			this.toggleAccordion14Show = e

			if(!e){

				const filteredArray = this.images.filter(item  => item.menuid  !== "neoplasia");
				this.images = filteredArray
			}


		},
		toggleAccordion15(e){
			this.toggleAccordion15Show = e
			// 添加图片
			const img = new Image();
			img.src = material;
			img.onload = () => {
				this.imgArr[14].image = img;
			}
		},
		toggleAccordion16(e){
			this.toggleAccordion16Show = e
		},

		 isMobile2() {
		    const userAgent = navigator.userAgent;
			const touchDeviceRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
			// 结合触摸事件检测
			const hasTouchEvents = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
			console.log("isMobile",touchDeviceRegex.test(userAgent),hasTouchEvents)
			this.isMobile = touchDeviceRegex.test(userAgent)
			 // this.drapImgWidth = this.isMobile ? 50 : 30
			
		},
		exportImage(){
			// return false
			this.deselect()
			setTimeout(() => {
				this.exportImage2()
			}, 100);
		},
		exportImage2() {
			// return false
			// 获取原生Konva对象
			const konvaStage = this.$refs.stageRef.getNode();

			// 创建高清画布（解决移动端模糊问题）
			const tempCanvas = document.createElement('canvas');
			const scaleFactor = window.devicePixelRatio  > 1 ? 2 : 1;

			// 设置画布尺寸
			tempCanvas.width  = this.configKonva.width  * scaleFactor;
			tempCanvas.height  = this.configKonva.height  * scaleFactor;

			// 绘制到临时画布
			const ctx = tempCanvas.getContext('2d');
			ctx.scale(scaleFactor,  scaleFactor);
			// konvaStage.drawScene(ctx);

			const _ = A => (A + "").padStart(2, "0")
			var x = new Date,
				p = `${x.getFullYear()}-${_(x.getMonth()+1)}-${_(x.getDate())}-${_(x.getHours())}h${_(x.getMinutes())}`;
			let I = document.createElement("a");


			if(this.isMobile){
				this.showImgDown = true
				this.downImg = konvaStage.toDataURL({
					type: "image/png",
					pixelRatio: 2048 / this.configKonva.width,
					quality: 1
				})
			}else{

				// prompt设置一个名称
				var name = prompt("请输入图片名称", "Virbac")
				if (!name) return;

				I.download = p + "-" + name + ".png", I.href = konvaStage
					.toDataURL({
						type: "image/png",
						pixelRatio: 2048 / this.configKonva.width,
						quality: 1
					}), I.target = "_blank", document.body.appendChild(I), I.addEventListener("click", A => {
						document.body.removeChild(I)
					}), I.click()

			}


		},
		
		getScrollHeight(){
			  // 桌面端精确计算 
			    this.windowHeight  = window.innerHeight  
			    
			    // 文档高度多引擎兼容方案 
			    this.pageHeight  = Math.max( 
			      document.body.scrollHeight, 
			      document.documentElement.scrollHeight, 
			      document.documentElement.offsetHeight  
			    )
			    
			    // 移动端视觉视口适配 
			    if (window.visualViewport)  {
			      this.visualHeight  = Math.floor(window.visualViewport.height  * 100) / 100 
			    }
				
				// console.log("高度",this.windowHeight, this.pageHeight,this.visualHeight,this.wapScrollHeight)
				this.scrollBarScroll()
				
		},
		scrollBarScroll(){
			//滚动条能滚动的距离
			this.scrollAreaHeight = this.windowHeight - window.innerWidth - 113 - 20
			// 红色滚动块 的 top 在 0 ~ scrollAreaHeight 移动
			//页面滚动的距离 this.wapScrollHeight 
			//this.scrollY
			
			
			//console.log('scrollAreaHeight',this.scrollAreaHeight)
		}





	},
};
</script>

<style>
body {
	background: #f5f6f7;
}

.form-check{
	position:relative;
}
.accordion-body .form-check{
	padding-left: 0;
}
.accordion-body .form-check input{
	position: absolute;
	left: 1.2em;
	top: 50%;
	margin-top: 4px;
	transform: translateY(-50%);
}
.accordion-body .form-check label{
	position: relative;
	z-index: 5;
	margin-left: -.5em;
	padding-left: 1.5em;
}

.downImgMask{
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 1999999;
	background: rgba(0, 0, 0, .75);
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	font-size: 30px;
	color: #fff;font-weight: bold;
}
.downImgMask img{
	width: 90vw;
	height: 90vw;
	object-fit: contain;
	margin-bottom: 10vw;
}



.m-show{
	display: none!important;
}



::-webkit-scrollbar {
	    width: 8px;  /* 竖向滚动条宽度 */
	    height: 8px; /* 横向滚动条高度 */
	    background: rgba(200,200,200,0.2);
		
	}
	 
	::-webkit-scrollbar-thumb {
	    background: #888;
	    border-radius: 4px;
	
	}
	 
@media (max-width:1000px) {
	.m1000-hide{
		display: none!important
	}

}


.m-header-bar{
	position: fixed;
	left: 0;top: 0;
	right: 0;
	z-index: 2000;
	background: #fff;
}
.m-header-bar .btn{
	padding-top: 0;
	padding-bottom: 0;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}
@media (max-width: 575px) {
    .m-hide{
		display: none!important;;
	}
	.m-show{
		display: block!important;
	}
	.m-btns-box{
		position: fixed;
		z-index: 99;
		right: 5px;
		top: 100vw;
		margin-top: 15px;
		display: none!important;;
		flex-direction: column;
		justify-items: right;

	}
	.m-btns-box .d-flex{
		flex-direction: column;
		justify-items: right;
	}
	.m-btns-box .btn{
		margin-bottom: 10px;
	}
	.m-btns-box #new-btn{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 5px!important;
	}
	.m-btns-box #new-btn svg{
		margin: 5px;
	}
	.m-screen{
		padding-left: 0;
		padding-right: 0;
	}
	#image-export-btn{
		position: fixed;
		right: 0;
		margin-right: 5px!important;
		bottom: 0px;
		z-index: 66;
		display: none;
	}
	#stage-wrapper{
		position: fixed;
		z-index: 66;
		left: 0;
		top: 113px;
		width: 100%;
		background: #fff;
	}
	.options-box{
		padding-top: calc(100vw + 113px);
	}
	#pathology-list{
		height: auto!important;
		overflow: visible;
		padding-bottom: 20px;
	}
	
	
	::-webkit-scrollbar {
	    width: 8px; 
	    height: 8px;
	    background: rgba(200,200,200,0.2);
		display: none;
	}
	 
	::-webkit-scrollbar-thumb {
	    background: #888;
	    border-radius: 4px;
		display: none;
	}
	 
	
	
}


.m-scroll{
	position: fixed;
	top: calc(100vw + 113px);
	right: 2px;
	bottom: 0;
	width: 5px;
	background: #eee;
	border-radius: 10px;
}

.m-scroll-bar{
	width: 8px;
	height: 20px;
	background: #F29527;
	border-radius: 10px;
}

/* @supports (scrollbar-width: none) {
  body,html,div{
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
  }
} */

/* 这里添加样式优化 */
/* 控制面板按钮组 */
.m-btns-box .btn {
  margin: 0 5px;
  position: relative;
  overflow: hidden;
}

.m-btns-box .btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: 0.6s;
}

.m-btns-box .btn:hover::after {
  left: 100%;
}

/* 移动端头部按钮 */
.m-header-bar .btn {
  font-size: 12px !important;
  border-radius: 6px;
  padding: 6px 12px;
  line-height: 1.2;
}

/* 下载按钮特殊样式 */
#image-export-btn {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

#image-export-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(242, 149, 39, 0.4);
}

#image-export-btn:active {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(242, 149, 39, 0.3);
}

/* #image-export-btn svg {
  transition: transform 0.3s ease;
  margin-right: 5px;
}

#image-export-btn:hover svg {
  transform: translateY(2px);
} */

/* 辅助清除按钮样式 */
button.btn-new {
  transition: all 0.3s ease;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

button.btn-new:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

button.btn-new:active {
  transform: scale(0.98);
}

/* 移动端按钮统一样式 */
@media (max-width: 575px) {
  .m-header-bar .btn {
    font-size: 12px !important;
    border-radius: 8px;
    padding: 6px 12px !important;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.help-bg {
	background: #f5f6f7;
	position: fixed;
	inset:0;
	z-index:999999
	
	
}
</style>
<style lang="less">
	
</style>
